module.exports = __webpack_public_path__ + "img/spartan-carpentry-millwork-cabinetry-07-large.abac1714.jpg";